declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
//import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { ApiRequestModel } from '../../../../models/api_request_model';
import { SpinnerService } from '../../../../services/spinner.service';
import { AppData } from '../../../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { DOCService } from '../../../../services/doc.service';
import { DownloadFileRequest } from '../../../../models/docs/doc.model';
import { ActorIdentitiesRequest, ActorDocRequest, ActorDocController, SaveCounsellingPlanRequest, PatientInfoByFormattedCodeController, PatientInfoByFormattedCodeRequest, IvfPlanActivityTemplateController, IvfPlanActivityTemplateRequest } from '../../../../models/actor/actor';
import { ActorService } from '../../../../services/actor.service';
import { DBOperation } from '../../../../enums/enum';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

import * as alertFunctions from '../../../../../shared/data/sweet-alerts';
import { NGXToastrService } from '../../../../../shared/services/toastr.service';

@Component({
  selector: 'selectactivity',
  templateUrl: './selectactivity.modal.html',
  styleUrls: ['./selectactivity.modal.scss']
})

export class NgbSelectActivityModal implements OnInit {


  @Input() ActorDocCode;
  @Input() DownloadActorImageFileExtension: string;
  @Input() DownloadActorImageFile: string;
  @Output() passEntry: EventEmitter<any> = new EventEmitter();
  @Input() CycleType: string;
  @Input() Protocol: string;
  @Input() CanEdit: number;
  @Input() CanShow: number;

  DOB: NgbDateStruct;
  maxDate: NgbDateStruct;
  minDate: NgbDateStruct;
  NewDate: Date;
  StartDate: NgbDateStruct;
  RecommendedPackage: string;
  Doctor: string;
  PackageCost: number;
  SelectEmi: boolean;
  Concerns: string;
  AddRemarks: string;
  file: File;
  fileList: FileList;



  FileExtension: string = "";
  MaritalStatus: string;
  JobType: string;
  public isRequesting: boolean = false;
  public ApiResData: ApiResponseModel;
  public ApiReqData: ApiRequestModel
  private modalRef: NgbModalRef;
  DocFriendlyName: string = "";
  CurrentIvfPlanActivityTemplateController: IvfPlanActivityTemplateController;
  CurrentIvfPlanActivityTemplateRequest: IvfPlanActivityTemplateRequest;
  LoadIvfPlanActivity() {
    this.CurrentIvfPlanActivityTemplateRequest = new IvfPlanActivityTemplateRequest();
    this.CurrentIvfPlanActivityTemplateRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetIvfPlanActivityTemplateController();
  }
  GetIvfPlanActivityTemplateController() {
    this.StartRefreshing();
    this.CurrentIvfPlanActivityTemplateRequest.CycleType = this.CycleType;
    this.CurrentIvfPlanActivityTemplateRequest.Protocol = this.Protocol;
    //alert(this.Protocol);
    //this.CurrentServiceCategoriesRequest.ParentCode = -1;
    //this.CurrentIvfPlanActivityTemplateRequest.PlanTemplateCode = this.SelectedTemplate.PlanTemplateCode;
    this.CurrentIvfPlanActivityTemplateRequest.ConditionalOperator = 30;
    this.actorservice.GetIvfPlanActivityTemplateController(this.CurrentIvfPlanActivityTemplateRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          //alert();
          this.CurrentIvfPlanActivityTemplateController = this.ApiResData.Result;
          //this.pdata = this.CurrentServiceCategoriesController;
          //alert(this.CurrentServiceCategoriesController.length);
          //this.ShowService = false;
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );

  }


  

  

  @ViewChild('f') IdentitiesDocForm: NgForm;
  public UploadActorDoc: any;

  public CanDownLoadActorDoc: number

  public CanNurseView: number =0 ;



  constructor(public activeModal: NgbActiveModal, private loaderService: SpinnerService, private docservice: DOCService,
    private router: Router, private route: ActivatedRoute, private actorservice: ActorService, private tosterservice: NGXToastrService, private parserFormatter: NgbDateParserFormatter) { }
  ngOnInit() {

    //this.LoadPatients();

    this.LoadIvfPlanActivity();

    this.NewDate=new Date

  }


  User: string;
  User2: number;
  passback(l: IvfPlanActivityTemplateController) {
    this.User = l.ActivityDescription;
    this.User2 = l.ActivityTemplateCode;
    this.passEntry.emit({ make: this.User, value:this.User2 });
    //this.passEntry.emit(this.User2);
    this.activeModal.dismiss('Cross click');
  }
  criteriaChange(value: any) {
    
  }
 
  
private stopRefreshing() {
  this.loaderService.displayLoader(false);
  this.isRequesting = false;
}
  private StartRefreshing() {
  this.loaderService.displayLoader(true);
  this.isRequesting = true;
  }
  editfollicular() {
    this.router.navigate(['nurse/editfollicular']);
    this.activeModal.close();
  }
}





  //GetActorDocController() {
  //  this.StartRefreshing();
  //  this.docservice.GetActorDocController(this.CurrentActorDocRequest)
  //    .subscribe((result) => {
  //      this.ApiResData = result;
  //      if (!this.ApiResData.hasError) {

  //        this.CurrentActorDocController = this.ApiResData.Result;
  //        this.initGridButton();
  //        this.stopRefreshing();

  //      }
  //      else {
  //        this.stopRefreshing();
  //        if (this.ApiResData.ErrorData != "") {

  //          alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
  //        }
  //        else {
  //          alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
  //        }
  //      }

  //    },


  //    (error) => {

  //      if (error == "401 - Unauthorized") {
  //        alertFunctions.AlertParamEr(error);
  //        this.stopRefreshing();



  //      }
  //      else {
  //        alertFunctions.AlertParamEr(error);
  //        this.stopRefreshing();
  //      }
  //    }


  //    );

  //}

  

  /////////////////////////



  //

  // https://www.codeproject.com/Articles/1195569/Angular-Data-Grid-with-Sorting-Filtering-Export-to
  // dbops: DBOperation;
  //Grid Vars start














  /////////////////////////

